import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
import {
    animationSpeed, skeletonBackgroundColor, skeletonForegroundColor,
    textBlockBorderRadius,
} from '~/src/components/skeletons/knowledge-base-banners-skeleton/knowledge-base-banners-skeleton.constants';
import * as Styled from './button-loader.styles';

export const ButtonLoader = (props: IContentLoaderProps) => (
    <ContentLoader
        speed={animationSpeed}
        width={'100%'}
        height={'100%'}
        backgroundColor={skeletonBackgroundColor}
        foregroundColor={skeletonForegroundColor}
        {...props}
    >
        <Styled.ButtonRect xPos={0} yPos={0} rx={textBlockBorderRadius} ry={textBlockBorderRadius} />
    </ContentLoader>
);
